export enum BannerActions {
  SCROLL_TO_CHAT = 'scroll-to-chat'
}
